import { defineStore } from 'pinia'
import { fetchBoostrapData, fetchQuestionnaireData, fetchSnapshotData } from '../API/MerchantAPI'

export const useMerchant = defineStore('merchant', {
  state: () => ({
    merchantId: 0,
    merchantLocations: [],
    merchantQuestions: [],
    merchantSnapshots: [],
    tattleResponse: {},
    questionnaireResponse: {},
  }),
  getters: {
    getMerchantLocations(state) {
      return state.merchantLocations
    },
    getMerchantQuestions(state) {
      return state.merchantQuestions
    },
    getMerchantSnapshots(state) {
      return state.merchantSnapshots
    },
    getMerchantId(state) {
      return state.merchantId
    },
  },
  actions: {
    async fetchAndStoreBootstrapData(slug: string) {
      try {
        this.tattleResponse = await fetchBoostrapData(slug)
        this.merchantId = this.tattleResponse.merchant.id
        this.merchantLocations = this.tattleResponse.merchant.locations
      } catch (error) {
        console.error('Error posting locations:', error)
      }
    },

    async fetchAndStoreQuestionnaireData(locationId: number) {
      try {
        this.questionnaireResponse = await fetchQuestionnaireData(this.merchantId, locationId)
        this.merchantQuestions = this.questionnaireResponse.questionnaires
      } catch (error) {
        console.error('Error posting questionnaires:', error)
      }
    },

    async fetchAndStoreSnapshotData(locationId: number, questionnaireId: number) {
      try {
        this.questionnaireResponse = await fetchSnapshotData(this.merchantId, locationId, questionnaireId)
        this.merchantSnapshots = this.questionnaireResponse
      } catch (error) {
        console.error('Error posting snapshots:', error)
      }
    },
  },
})
